import { store } from "@/Redux/store";
import ProtectedRoute from "@/components/ProtectedRoute/ProtectedRoute";
import Player from "@/components/common/Player/Player";
import { PlayerProvider } from "@/context/PlayerContext";
import "@/styles/globals.css";
import { Provider } from "react-redux";
import { GoogleAnalytics  } from '@next/third-parties/google';
import { PageViewTracker } from "@/utilies/analytics";
import VideoPlayer from "@/components/common/videoPlayer";

export default function App({ Component, pageProps }) {
  const id = process.env.NEXT_PUBLIC_URL_GOOGLE_TAG_ID;

  const getLayout = Component.getLayout || ((page) => page);
  return getLayout(
    <Provider store={store}>
      <ProtectedRoute>
        <PlayerProvider>
          <GoogleAnalytics gaId={id} />
          <PageViewTracker />
          <Component {...pageProps} />
          <Player />
        </PlayerProvider>
      </ProtectedRoute>
    </Provider>
  );
}